module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"ru":{"in":"в","today_in":"Сегодня","recommended_to_subscribe":"Рекомендуем подписаться","subscribe":"Подписаться","hide":"Скрыть","subscribe_already":"Вы подписаны","lastday_in":"Вчера"}}')
  delete Component.options._Ctor
}
